

















import { Component, Prop, Vue as VueDecorator } from "vue-property-decorator";
import { SearchQueryDebouncer } from "@/utils/SearchQueryDebouncer";

/**
 * Shared, visually-consistent search field for selection dialogs.
 *
 * Owns its own debounce: emits a debounced `input` with the query string (empty
 * string clears immediately). Bind with `:value` + `@input`, e.g.
 *   <search-field :value="searchQuery" @input="searchQuery = $event" />
 */
@Component
export default class SearchFieldComponent extends VueDecorator {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: true }) autofocus!: boolean;

  private debouncer = new SearchQueryDebouncer((query: string) =>
    this.$emit("input", query)
  );

  onInput(value: string | null) {
    // `clearable` emits null on clear → treat as empty (debouncer clears instantly).
    this.debouncer.debounceSearch(value ?? "");
  }
}
